var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AUDIO_EFFECT_NAME } from '../audio-helper';
import BaseAudioEffector from './base-audio-effector';
/**
 * 压缩器效果
 * 主要作用就是压缩音频的动态范围，让整个音乐都处于合理的音量范围
 */
var CompressorEffector = /** @class */ (function (_super) {
    __extends(CompressorEffector, _super);
    function CompressorEffector(audioCtx, audioSource, logger) {
        var _this = _super.call(this, audioCtx, audioSource, logger) || this;
        _this.effectorName = 'Compressor';
        _this.compressor = audioCtx.createDynamicsCompressor();
        return _this;
    }
    CompressorEffector.prototype.connectBy = function (node) {
        if (!node || !this.compressor) {
            return null;
        }
        node.connect(this.compressor);
        this.setPreConfigName(AUDIO_EFFECT_NAME.DEFAULT);
        return this.compressor;
    };
    CompressorEffector.prototype.disconnect = function () {
        var _a;
        if (!this.compressor) {
            return;
        }
        this.compressor.disconnect();
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.effectorName, " disconnect()"));
    };
    CompressorEffector.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.compressor = null;
    };
    /**
     * 设置效果器预设值
     */
    CompressorEffector.prototype.setPreConfigName = function (effectName) {
        var _a;
        if (effectName === this.currPreCfgName || !this.compressor) {
            return;
        }
        // 在controller里activeEffects方法加入对cpsEffector.using=false处理，就无需在此处专门处理默认音效
        this.currPreCfgName = effectName;
        this.compressor.attack.value = cpsPreCfg.attack;
        this.compressor.knee.value = cpsPreCfg.knee;
        this.compressor.ratio.value = cpsPreCfg.ratio;
        this.compressor.release.value = cpsPreCfg.release;
        this.compressor.threshold.value = cpsPreCfg.threshold;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("CompressorEffector setPreConfigName() effectName=".concat(effectName));
    };
    return CompressorEffector;
}(BaseAudioEffector));
export default CompressorEffector;
/**
 * Compressor音效预配置
 */
export var cpsPreCfg = {
    attack: 0.003,
    knee: 30,
    ratio: 12,
    release: 0.25,
    threshold: -24,
};
